<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .myAmpleon .content {
        // There is some margin-top added elsewhere for the content class on this breakpoint
        // We don't need it on this page
        @media screen and (max-width: 767px) {
            margin-top: 0;
        }
    }

    .sidebar, .banner {
        display: none;
    }

    .content {
        left: 0;
        width: 100% !important;
    }

    h3.page-title {
        color: #000 !important;
        font-size: 24px;
        line-height: 29px;
    }

    .row__registration-successful {
        min-height: 100vh;

        @media (max-width: 991px) {
            flex-direction: column-reverse;
            min-height: auto;
        }

        .parametric-intro {
            margin: 0;
        }

        .page-title {

            @media (max-width: 767px) {
                padding: 15px 0 !important;
            }
        }

        .image-section {

            @media (max-width: 991px) {
                height: 270px;
            }

            @media (max-width: 767px) {
                height: 402px;
            }
        }
    }

    .image-section {
        display: flex;
        flex-direction: column;
        font-family: "Open Sans", sans-serif;
        position: relative;
        height: 100vh;
        background-image: url("../assets/images/register-img.jpg");
        background-position: center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .top-bar {
        background-color: #003b71;
        height: 60px;
        width: 100%;
        top: 50px;
        left: 0;
        z-index: 2;
        overflow: hidden;
    }

    .row--flex {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .svg-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;

        path {
            fill: #ffffff;
        }
    }

    .col-spacing-75 {
        padding: 0 75px;

        @media (max-width: 991px) {
            padding: 0 25px;
        }

        @media (max-width: 767px) {
            padding: 0 15px;
        }
    }

    .invalid-feedback {
        color: #ff0000;
        margin-left: 12px;
        margin-bottom: 0;
    }

    .reset-pass-paragraph {
        margin-bottom: 58px;
    }

    .parametric-intro {
        margin: 0;
        padding-top: 43px !important;
    }

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }

    .btn {
        padding-left: 35px;
        padding-right: 35px;
        margin-top: 27px;
    }
</style>

<template>
    <div class="registration-wrapper">
        <div class="top-bar"></div>
        <div class="row row--flex row__registration-successful">
            <div class="col-md-6 col-spacing-75">
                <div class="parametric-intro">
                    <h3 class="page-title">Password reset</h3>
                    <p v-if="!resetError" class="reset-pass-paragraph">Please enter the required information below to
                        change your password for the account associated with {{user.email}}.</p>
                    <p v-if="resetError" class="reset-pass-paragraph">Your password reset link has expired. If you still
                        can't login, please restart with the reset procedure
                        <router-link :to="{path: '/reset-password'}"><b>here</b></router-link>
                        .
                    </p>
                </div>
                <div v-if="!resetError" class="account-question">
                    <form @submit.prevent="handleSubmit">
                        <div class="row form-row">
                            <div class="form-group col-md-12">
                                <PasswordFieldWithStrengthMeter
                                    v-model="user.password"
                                    :email="user.email"
                                    :token="user.token"
                                    :submitted="submitted"
                                    :include-password-history="true"
                                    @valid="validatePasswordHistory"
                                >
                                </PasswordFieldWithStrengthMeter>
                            </div>

                            <div class="form-group col-md-12">
                                <input type="password" v-model="user.confirmPassword" class="form-control"
                                       id="confirmPassword" placeholder="Confirm Password *"
                                       :class="{ 'is-invalid': formErrors && $v.user.confirmPassword.$error }">
                                <div v-if="formErrors && $v.user.confirmPassword.$error" class="invalid-feedback">
                                    <p v-if="formErrors && !$v.user.confirmPassword.required">Please confirm
                                        password.</p>
                                    <p v-else-if="!$v.user.confirmPassword.sameAsPassword">Passwords don't match. Please
                                        try again.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row form-row">
                            <div class="form-group col-md-12">
                                <button type="submit" :disabled="isPending" class="btn btn-primary">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, sameAs} from "vuelidate/lib/validators";
    import {UserService} from "@/common/api.service";
    import {RESET_PASSWORD} from "@/store/actions.type";
    import {STATUS, mapAsyncGetters} from "@/store/utils/async";
    import PasswordFieldWithStrengthMeter from "@/components/PasswordFieldWithStrengthMeter";
    import {mapGetters} from "vuex";

    const customPassword = value => {
        return /^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?!.*\s).{6,}$/.test(value)
    };

    export default {
        name: "PasswordReset",
        components: {
            PasswordFieldWithStrengthMeter
        },
        data() {
            return {
                user: {
                    email: "",
                    password: "",
                    confirmPassword: "",
                    token: ""
                },
                submitted: false,
                formErrors: false,
                resetError: false,
                validPasswordHistory: false
            };
        },
        validations: {
            user: {
                password: {
                    required,
                    customPassword
                },
                confirmPassword: {required, sameAsPassword: sameAs('password')},
            }
        },
        computed: {
            ...mapAsyncGetters(RESET_PASSWORD)
        },
        watch: {
            status: function (newValue) {
                if (this.isFinished) {
                    if (newValue === STATUS.SUCCESS) {
                        this.$router.push("/");
                    } else if (newValue === STATUS.FAILURE) {
                        this.resetError = true;
                    }
                }
            }
        },
        async mounted() {
            if (this.$route.query.email) {
                // '+' is url encoded to '%20' in browsers' address bar, and the '%20' is then decoded to ' '.
                this.user.email = this.$route.query.email.trim().replace(' ', '+');
            }
            if (this.$route.query.token) {
                this.user.token = this.$route.query.token;
            }
            await UserService.validatePasswordToken(this.user)
                .then(response => {
                    if (response.status !== 200) {
                        this.resetError = true;
                    }
                })
                .catch(error => {
                    this.resetError = true;
                });
        },
        methods: {
            validatePasswordHistory(valid) {
                this.validPasswordHistory = valid;
            },
            handleSubmit() {
                // stop here if form is invalid
                this.$v.$touch();
                this.submitted = true;
                if (this.$v.$invalid || !this.validPasswordHistory) {
                    this.formErrors = true;
                } else {
                    this.$store.dispatch(RESET_PASSWORD, this.user);
                }
            }
        }
    };
</script>

